import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    width: '700px ',
    height: 'auto',
    marginTop: '50px',
  },
  topBar: {
    backgroundColor: '#F6F6F6',
    padding: '16px 16px',
  },
  modal: {
    marginTop: '50px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0),
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '133.4%',
    color: '#000000',
    textTransform: 'capitalize',
    '& span': {
      color: '#5081FF',
      fontWeight: 300,
    },
  },
  text: {
    width: '100%',
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    fontSize: 15,
    color: 'black',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
    '& span': {
      fontWeight: 100,
      marginLeft: theme.spacing(1),
    },
  },
  fullRow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '100%',
    flexWrap: 'wrap',
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  flexBox: {
    display: 'flex',
    padding: '24px',
  },
  formContainer: {
    flex: 1,
  },
  progressBar: {
    height: '25px',
    width: '100%',
  },
}));
